import { render, staticRenderFns } from "./MaterialSettingTabs.vue?vue&type=template&id=0ea59412&scoped=true&"
import script from "./MaterialSettingTabs.vue?vue&type=script&lang=js&"
export * from "./MaterialSettingTabs.vue?vue&type=script&lang=js&"
import style0 from "./MaterialSettingTabs.vue?vue&type=style&index=0&id=0ea59412&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea59412",
  null
  
)

export default component.exports